module.exports = __webpack_public_path__ + "static/media/shutterstock_172135856_0020_021.ae9f2851.png";